import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';

export class Homes extends AbstractComponent {
  init() {
    const slider = this.el.querySelector('.swiper');
    const filterButtons = this.el.querySelectorAll('[data-filter]');
    const items = this.el.querySelectorAll('[data-item]');

    filterButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const filter = button.getAttribute('data-filter');
        filterButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.filter === filter));
        this.el.classList.add('is-filtered');

        items.forEach((item) => {
          if (filter === 'all') {
            item.style.display = 'block';
          } else {
            item.classList.toggle('is-active', item.getAttribute('data-item') === filter);
          }
        });

        slider?.swiper?.update();
      });
    });

    // check hash for #1-bedroom etc. and filter accordingly
    const hash = window.location.hash && window.location.hash.includes('bedroom') ? window.location.hash : null;
    if (hash) {
      const filter = hash.replace('#', '');
      filterButtons.forEach((button) => {
        button.dataset.filter === filter && button.click();
      })
    }
  }
}

register('homes', Homes);
